//-------------------------------------------------------------------------------------------------- Imports
import moment from "moment";

//-------------------------------------------------------------------------------------------------- Parse date
export const parseDate = (date: Date) => {
    const months = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre",
        "octubre", "noviembre", "diciembre", 
    ];

    return (`
        ${moment(date).format("DD")}
        ${months[Number.parseInt(moment(date).format("MM"))]}
        ${moment(date).format("YYYY")} - ${moment(date).format("hh:mm")}
    `);
};

const CURP_REGEX = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

export const validateCurpFormat = (curp: string): boolean => {

  if (!curp) {
    return false;
  }

  const upperCaseCurp = curp.toUpperCase();

  return CURP_REGEX.test(upperCaseCurp);
}

export const getCurpValidationError = (curpValue: string): string => {
    const upperCaseCurp = curpValue.toUpperCase();

    if (!upperCaseCurp) {
        return 'El CURP es obligatorio.';
    }
    
    if (upperCaseCurp.length < 18) {
        return 'La CURP debe tener 18 caracteres.';
    }

    if (!validateCurpFormat(upperCaseCurp)) {
        return 'Formato de CURP incorrecto.';
    }

    return ''; 
};
